/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IUser {
        id: number | string;
        username: string;
        fullname: string;
        password: string;
        email: string;
        avatar: string;
        enabled: boolean;
        created: Date;
        organizationId: number;
        authorities: IAuthority[];
        lastlogin: Date;
        failedlogins: number;
    }

    export interface IAuthority {
        authority: string;
    }

    export class User implements IUser {
        public id: number | string;
        public username: string;
        public fullname: string;
        public password: string;
        public email: string;
        public avatar: string;
        public enabled: boolean;
        public created: Date;
        public organizationId: number;
        public authorities: IAuthority[];
        public lastlogin: Date;
        public failedlogins: number;

        public static createCopy(original: IUser): User {
            return new User(original.id,
                            original.username,
                            original.fullname,
                            original.password,
                            original.email,
                            original.avatar,
                            original.enabled,
                            original.created,
                            original.organizationId,
                            original.authorities,
                            original.lastlogin,
                            original.failedlogins);
        }

        public static createEmpty(): User {
            return new User();
        }

        constructor(id?: number | string,
                    username?: string,
                    fullname?: string,
                    password?: string,
                    email?: string,
                    avatar?: string,
                    enabled?: boolean,
                    created?: Date,
                    organizationId?: number,
                    authorities?: IAuthority[],
                    lastlogin?: Date,
                    failedlogins?: number) {
            this.id = id;
            this.username = username;
            this.fullname = fullname;
            this.password = password;
            this.email = email;
            this.avatar = avatar;
            this.enabled = enabled;
            this.created = created;
            this.organizationId = organizationId;
            this.authorities = authorities;
            this.lastlogin = lastlogin;
            this.failedlogins = failedlogins;
        }
    }
}